import React from 'react';
import styled from 'styled-components';
import { FlexBetween, FlexibleDiv } from '../../../../styled/common';
import { PlaceholderBlock } from '../../../../styled/placeholders.styled';
import { Breakpoints } from '../../../../styled/constants';

const HeaderPlaceholder = styled(FlexBetween)`
  display: none;

  @media (min-width: ${Breakpoints.tablet}px) {
    display: flex;
    height: 84px;
    padding: 0 40px;
  }

  @media (min-width: ${Breakpoints.desktop}px) {
    padding: 0 20px;
  }
`;

const ActionsWrapper = styled(FlexibleDiv)`
  gap: 15px;
`;

export const CurrentItemTitlePlaceholder: React.FC = () => {
  return (
    <HeaderPlaceholder>
      <PlaceholderBlock
        height="53px"
        width="60%"
        margin="0"
        borderRadius="14px"
      />

      <ActionsWrapper>
        <PlaceholderBlock
          height="54px"
          width="54px"
          margin="0"
          borderRadius="14px"
        />
        <PlaceholderBlock
          height="54px"
          width="54px"
          margin="0"
          borderRadius="14px"
        />
      </ActionsWrapper>
    </HeaderPlaceholder>
  );
};
